import React from "react";
import ResponsiveDrawer from "./Nav";
import { useAuth } from "../context/AuthContext";

function AppContent() {
  const { isAuth, isLoading } = useAuth();

  const LazyLogin = React.lazy(() => import("./Login"));

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isAuth ? (
    <ResponsiveDrawer />
  ) : (
    <React.Suspense fallback={<div>Loading...</div>}>
      <LazyLogin />
    </React.Suspense>
  );
}

export default AppContent;
